module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3UzaX"))).then(() => parcelRequire('4nEZU'));